var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EB008B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.3,59.6L78.3,59.6c-4.8,0-9.5,1.9-12.9,5.3C61.9,68.3,60,73,60,77.8v274.8c0,10,8.3,18.3,18.3,18.3 c42.6,0.2,114.1,9,163.4,60.5V144c0-3.4-0.9-6.6-2.6-9.3C198.8,69.6,121,59.7,78.3,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452,352.6V78c0-5-1.9-9.5-5.3-12.9c-3.4-3.4-7.9-5.3-12.8-5.3l0,0c-42.8,0.2-120.5,10-161,75.2 c-1.7,2.6-2.6,5.9-2.6,9.3v287.5c49.3-51.5,120.7-60.5,163.4-60.5C443.7,371.1,452,362.8,452,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.7,123h-13.3v229.6c0,25.7-21,46.7-46.7,46.7c-36.2,0.2-95.8,7.2-138.1,47.1 c73.1-17.9,150.2-6.2,193.9,3.8c5.5,1.2,11.2,0,15.5-3.6c4.3-3.4,6.9-8.8,6.9-14.3v-291C512,131.3,503.7,123,493.7,123z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,352.6V123H18.3C8.3,123,0,131.3,0,141.3v291.2c0,5.7,2.6,10.9,6.9,14.3c4.3,3.4,10,4.8,15.5,3.6 c44-10,120.8-21.5,193.9-3.8c-42.2-40-101.9-47.1-138.1-47.1C52.6,399.3,31.5,378.5,31.5,352.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesSummary);
export default __webpack_public_path__ + "static/media/SalesSummary.33ad2b9bc700d2d87e79b677b73914b2.svg";
export { ForwardRef as ReactComponent };